(function() {
  "use strict";

  angular.module("sempraWebapp").constant("slTranslations", {
    MESSAGE:"Sporočilo",
    ERROR_TITLE:"Napaka",
    ERROR_MESSAGE:"Prišlo je do napake med izvajanjem operacije.",
    ERROR_LOGIN:"Napaka med prijavljanjem. Elektronski naslov ni veljaven ali se ne ujema z geslom. Prosimo, poskusite ponovno.",
    ERROR_LOGIN_ROLE:"Vloga za trenutno blagovno znamko aplikacije ni veljavna",
    OK:"OK",
    CANCEL:"Prekliči",
    YES:"Da",
    NO:"Ne",
    FROM:"Od",
    TO:"Do",
    DELETE:"Izbriši",
    SIGN_OUT:"Odjavi se",
    NAME:"Ime",
    DATE:"Datum",
    PIECES:"kom",
    HOURS:"Ure",
    DAYS:"Dnevi",
    MONTH:"Mesec",
    MONTHS:"Meseci",
    YEAR:"Leto",
    BOX:"Pralno mesto",
    SEARCH:"Išči",
    ALL_USERS:"Vsi uporabniki",
    ARE_YOU_SURE:"Ali ste prepričani?",
    BACK:"Nazaj",
    AMOUNT:"Znesek",
    DESCRIPTION:"Opis",
    FORGOT_PASSWORD_ERROR_MSG:"Prišlo je do napake. Preverite vaš elektronski naslov in poskusite ponovno.",
    REQUIRED_FIELD:"Polje je obvezno",
    LOGOUT_TITLE:"Ali ste prepričani, da se želite odjaviti?",
    LOGOUT_MSG:"Vse ne shranjene spremembe bodo izbrisane.",
    ACTIVATION_ACCOUNT:"Uspešno ste aktivirali račun",
    UNKNOWN_ERRROR_NOTIFICATION:"Prišlo je do neznane napake.",
    CONTINUE:"Nadaljujte",
    DATA_NOT_AVAILABLE:"Podatki niso najdeni.",
    SELECT:"Izberi",
    SELECT_CURRENCY:"Izberite valuto",
    UPLOAD:"Pošlji",
    PHONE:"Telefon",
    WEBSITE:"Spletna stran",
    WORKING_HOURS:"Delovni čas",
    INSERT:"Vnesi",
    TEXT:"Besedilo",
    CREATED:"Ustvarjeno",
    VALID_UNTIL:"Veljavno do",
    SAVE:"Shrani",
    TOKENS:"Žetoni",
    DELETE_COMPANY_HISTORY:"Trajno izbriši zgodovino podjetja?",
    DELETE_COMPANY_HISTORY_MESSAGE:"OPOZORILO: Po pritisku na ta gumb bodo vse transakcije iz vaše avtopralnice trajno izbrisane! Teh podatkov po brisanju ni mogoče obnoviti. ",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Ali ste prepričani, da želite trajno izbrisati vse podatke o transakcijah? ",
    HISTORY_SUCCESSFULY_DELETED:"Zgodovina je uspešno izbrisana",
    HELP:"Pomoč",
    VALUE:"Vrednost",
    ACTIVATING_ACCOUNT_ERROR:"Prišlo je do napake med aktiviranjem vašega računa R2W. Prosimo, poskusite ponovno in če bo težava še vedno prisotna, kontaktirajte support@ready2wash.com.",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Dobrodošli v avtopralnici Kärcher",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Dobrodošli na R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Prosimo, vpišite vaše novo geslo in ga potrdite za aktiviranje vašega računa R2W. Samodejno boste prijavljeni v sistem po uspešni verifikaciji gesla.",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Vaše uporabniške podatke lahko spremenite kasneje v aplikaciji.",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Avtopralnica Kärcher ",
    RESET_PASSWORD_WELCOME_MSG:"Avtopralnica R2W",
    RESET_PASSWORD_WELCOME_MSG_2:"Vnesite novo geslo in ga potrdite, da ponastavite staro geslo. Po uspehu boste samodejno prijavljeni v aplikacijo",
    RESET_PASSWORD_WELCOME_MSG_3:"Uporabniške nastavitve lahko pozneje spremenite v aplikaciji",
    ENTER_NEW_PASSWORD:"Vnesite novo geslo.",
    REPEAT_NEW_PASSWORD:"Ponovite geslo.",
    PASSWORD_MIN_LENGTH:"Geslo mora imeti vsaj 8 znakov.",
    PASSWORD_MAX_LENGHT:"Geslo ne sme imeti več kot 32 znakov.",
    PASSWORD_PATTERN:"Geslo mora vsebovati vsaj eno veliko in eno malo črko.",
    PASSWORD_MATCH:"Gesli nista enaki.",
    ACTIVATE:"Aktiviraj",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Uspešno ste poslali zahtevo. Prosimo, preverite e-pošto za potrditveno sporočilo",
    VALIDATION_REQUIRED:"Obvezno polje",
    VALIDATION_EMAIL:"Neveljaven elektronski naslov.",
    VALIDATION_INTEGER_NUMBER:"Vrednost mora biti celo število.",
    VALIDATION_HOURS_VALUE:"Vrednost mora biti med 0 in 23.",
    VALIDATION_MINUTES_VALUE:"Vrednost mora biti med 0 in 59.",
    VALIDATION_NOT_A_DATE:"Vnesena vrednost ni datum.",
    VALIDATION_FROM:"Od datuma, večjega od",
    VALIDATION_TO:"Do danes manj kot od",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Ta podatek že obstaja v bazi podatkov.",
    PASSWORD_VALIDATION_PATTERN_NEW:"Geslo mora vsebovati vsaj eno veliko črko in eno številko. Prazna polja niso dovoljena.",
    VALIDATION_PERCENT_VALUE:"Vrednost mora biti med 1 in 999.",
    NUMBERS_ONLY_100:"Štetje do 100 ",
    NUMBERS_ONLY_1000:"Štetje do 1000",
    POSITIVE_NUMBERS_ONLY:"Samo pozitivno število",
    GRID_PAGER_PAGE:"Stran",
    GRID_PAGER_ROWS_PER_PAGE:"Vrstic na stran",
    GRID_PAGER_PAGE_OF:"od",
    BREAD_CRUMBS_HOME:"Začetna stran",
    BREAD_CRUMBS_DASHBOARD_TECH:"Pregled pralnic",
    BREAD_CRUMBS_DETAILS:"Podrobnosti",
    BREAD_CRUMBS_SETTINGS:"Nastavitve",
    BREAD_CRUMBS_WORKING_HOURS:"Delovni čas",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Skupna vsota denarja po dnevih",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Povprečna vsota denarja po urah",
    BREAD_CRUMBS_NEW_USER_GROUP:"Ustvari uporabniško skupino",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Uredi uporabniško skupino",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Ustvari predlogo oglasa",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Uredi predlogo oglasa",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Ustvari oglas",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Uredi oglas",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Periodični pregled financ",
    LOGIN:"Prijava",
    EMAIL:"Elektronski naslov",
    PASSWORD:"Geslo",
    LANGUAGE:"Jezik",
    FORGOT_PASSWORD:"Pozabljeno geslo?",
    SUBMIT:"Potrdi",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Število alarmov v teku:",
    HEADER_VIEW_ALL_ALARMS:"Poglej vse alarme ... ",
    HEADER_MY_ACCOUNT:"Moj račun",
    HEADER_ACCOUNT_MANAGEMENT:"Urejanje računa",
    ACCOUNT_ALREADY_EXIST:"Elektronski naslov že obstaja.",
    NEWSLETTER_CONFIRMATION:"Pošlji obvestilo po e-pošti za stanje alarmov",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Dnevni pregled financ",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Pregled pralnic",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Nadzorna plošča",
    ASIDE_MENU_ALARMS:"Sporočila",
    ASIDE_MENU_FACILITIES:"Pralnice",
    ASIDE_MENU_REPORTS:"Poročila",
    ASIDE_MENU_REPORT:"Izbrano poročilo",
    ASIDE_MENU_LOYALTY:"Zvestoba",
    ASIDE_MENU_USER_GROUPS:"Uporabniške skupine",
    ASIDE_MENU_PERIODIC_SUMMARY:"Periodični pregled",
    ASIDE_MENU_MANAGING_TOKENS:"Upravljanje žetonov",
    ASIDE_MENU_NEWS:"Novosti",
    DAILY_FINANCES_TOTAL_MONEY:"Skupna vsota denarja",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Skupna vsota denarja za vse pralnice",
    DAILY_FINANCES_TOTAL_COINS:"Skupaj porabljenih kovinskih žetonov",
    DAILY_FINANCES_DOWNLOAD_CSV:"Prenos CSV",
    DAILY_FINANCES_ONLINE:"R2W (na spletu)",
    DAILY_FINANCES_OFFLINE:"Gotovina",
    DAILY_FINANCES_CHANGER:"Gotovina v menjalniku",
    DAILY_FINANCES_COINS:"Žetoni",
    REPORTS_FILTER:"Filter",
    REPORTS_TYPE_OF_REPORT:"Vrsta poročila",
    REPORTS_CHOOSE_FACILITY:"Izberi pralnico",
    REPORTS_PERIOD_1:"Obdobje 1 -",
    REPORTS_PERIOD_2:"Obdobje 2 -",
    MONEY_BY_DATE_REPORT:"Skupna vsota denarja po dnevih",
    R2W_BY_DATE_REPORT:"Skupna vsota plačil R2W žetoni (na spletu) po dnevu",
    COINS_BY_DATE_REPORT:"Skupno število porabljenih žetonov po dnevih",
    AVG_MONEY_BY_HOUR_REPORT:"Povprečna vsota denarja po urah",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Povprečna vsota denarja po dnevih",
    AVG_MONEY_BY_BOX_REPORT:"Poraba po pralnih mestih",
    COMPARE_PERIODS_REPORT:"Vzporedni prikaz po pralnici",
    TOTAL_USERS_BY_GROUP:"Skupno število uporabnikov  R2W po dnevih",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"uporabnikov",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"obiski",
    VISITS_COUNT_REPORT:"Število uporabnikov aplikacije R2W na število obiskov ",
    LOYALTY_PER_DAY_REPORT:"Število porabljenih lokalnih žetonov na dan",
    LOYALTY_PER_PAYMENT_METHOD:"Dani lokalni žetoni glede na plačilno sredstvo",
    VISITS:"Obiski",
    VISIT:"Obisk",
    TOTAL_SPENT_MONEY:"Skupni dohodek",
    MONEY:"Denar",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Skupni dohodek za obdobje",
    DOWNLOAD_CSV:"Prenos CSV",
    TOTAL_SPENT_COINS:"Skupno število porabljenih žetonov",
    TOTAL_USERS:"Skupno število uporabnikov",
    TOTAL_CREDIT_GIVEN:"Skupni porabljeni lokalni žetoni",
    EUROKEY_BY_DATE_REPORT:"Skupni znesek plačil z evro ključem",
    TOTAL_SPENT_EUROKEY:"Skupno porabljeno",
    SELECT_TYPE_OF_REPORT:"Izbrati morate vrsto poročila :)",
    NUMBER_OF_VISITS_TITLE:"Število obiskov",
    NUMBER_OF_USERS_TITLE:"Število uporabnikov",
    PIECES_TITLE:"Kosi",
    TOTAL_VISITS:"Skupaj obiskov",
    TOKENS_TITLE:"žetone",
    SEARCH_USERS_NO_RESULTS:"Ni uporabnikov za iskalni pogoj",
    SEARCH_USERS:"Iskanje uporabnikov",
    SEARCH_TELEPHONES:"Iskanje uporabnikov po mobilni telefonski številki",
    ADD_USER_TO_GROUP:"Dodaj uporabnika v skupino",
    REMOVE_USER_FROM_GROUP:"Izbriši uporabnika iz skupine",
    USER_GROUP_NAME_REQUIRED:"Ime uporabniške skupine je obvezno polje.",
    USER_GROUP_NAME:"Ime uporabniške skupine",
    USER_GROUPS_OVERVIEW:"Pregled uporabniških skupin",
    USER_COUNT:"Število uporabnikov",
    NEW_USER_GROUP:"Ustvari novo uporabniško skupino",
    DELETE_USER_GROUP:"Izbriši uporabniško skupino",
    UPDATE_USER_GROUP:"Uredi uporabniško skupino",
    DELETE_USER_GROUP_ERROR:"Prišlo je do napake med brisanjem izbrane uporabniške skupine. Prosimo, poskusite ponovno ali kontaktirajte tehnično podporo ...",
    CONFIRM_DELETE_USER_GROUP:"Ali ste prepričani, da želite izbrisati izbrano uporabniško skupino?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Akcije zvestobe, h katerim je bila dodeljena skupina, ne bodo več veljavne za uporabnike iz izbrisane skupine.",
    GROUP_NAME_MAX_LENGTH:"Ime skupine mora biti krajše od 255 znakov.",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Uporabnik je že v tej skupini.",
    MISSING_USER:"Manjka uporabnik",
    USER_NOT_ON_LIST:"Uporabnik ni na seznamu aktivnih uporabnikov. Preverite, ali je e-poštni naslov veljaven in poskusite znova.",
    UPLOAD_USER_GROUP:"Naložite seznam uporabniških skupin iz datoteke *.csv",
    UKNOWN_USERS:"Seznam neznanih uporabnikov",
    CAMPAIGN_TEMPLATE_RULE:"Pravilo oglasa",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Prišlo je do napake pri brisanju izbrane predloge oglasa. Prosimo, poskusite ponovno ali kontaktirajte tehnično podporo ...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Ali ste prepričani, da želite izbrisati izbrano predlogo oglasa?",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Ali ste prepričani, da želite izbrisati izbrano predlogo oglasa?",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Pregled predlog oglasa",
    DELETE_CAMPAIGN_TEMPLATE:"Izbriši predlogo oglasa",
    UPDATE_CAMPAIGN_TEMPLATE:"Uredi predlogo oglasa",
    CREATE_CAMPAIGN_TEMPLATE:"Ustvari novo predlogo oglasa",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Ime predloge oglasa je obvezno polje.",
    CAMPAIGN_TEMPLATE_NAME:"Ime predloge oglasa",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Obvezno polje",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"Podari",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"Dodaten čas",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Najprej izberite tip. Pralna mesta ali Mali stroji.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Izbriši pravilo",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Od",
    CAMPAIGN_TEMPLATE_RULE_TO:"do",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"ure",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minute",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Novo pravilo po številu obiskov",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Novo pravilo po količini porabljenih žetonov",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Novo pravilo po dnevih v tednu",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Dodaj novo pravilo",
    CAMPAIGN_TEMPLATE_RULE_1:"Vseh",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Vseh",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"žetonov, porabljenih v manj kot",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"obiskov v manj kot",
    CAMPAIGN_TEMPLATE_RULE_3:"dnevi",
    CAMPAIGN_TEMPLATE_RULE_4:"žetoni",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Seznam pravil je prazen.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Datum ne more biti v preteklosti",
    DELETE_CAMPAIGN_ERROR:"Prišlo je do napake pri brisanju izbranega oglasa. Prosimo, poskusite ponovno ali kontaktirajte tehnično podporo ...",
    CONFIRM_DELETE_CAMPAIGN:"Ali ste prepričani, da želite izbrisati izbran oglas?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W ni odgovoren za uporabniško izkušnjo, ki jo povzroči ta dejanje.",
    CAMPAIGNS_OVERVIEW:"Pregled oglasov",
    DELETE_CAMPAIGN:"Izbriši oglas",
    UPDATE_CAMPAIGN:"Uredi oglas",
    CREATE_CAMPAIGN:"Ustvari nov oglas",
    CAMPAIGN_ACTIVE:"Aktivna",
    CAMPAIGN_TEMPLATE:"Predloga",
    CAMPAIGN_GROUPS:"Skupine",
    CAMPAIGN_ALL_USERS:"Vsi uporabniki",
    CAMPAIGN_NAME:"Ime oglasa",
    CAMPAIGN_NAME_REQUIRED:"Ime oglasa je obvezno polje.",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Uporabniki blizu praga bonusa po dnevu",
    MESSAGE_TO_USERS:"Sporočilo filtriranim uporabnikom",
    SEND_MESSAGE:"Pošlji sporočilo",
    THRESHOLD:"Prag",
    TYPE:"Tip",
    TOTAL_MONEY_SPENT:"Skupna vsota porabljenega denarja v oglasu",
    NUMBER_OF_VISITS:"Skupno število obiskov v času oglasa",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Sporočilo mora imeti vsaj 10 znakov.",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Sporočilo ne sme imeti več kot 350 znakov.",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Besedilo sporočila je obvezno.",
    TECHNOLOGY:"Tehnologija",
    TAP_WATER:"Voda iz pipe",
    REVERSE_OSMOSIS:"Reverzna osmoza",
    SOFTENED_WATER:"Mehka voda",
    DOSER:"Dozirnik",
    STATUS:"Status",
    LAST_SYNCHRONIZATION:"Zadnja sinhronizacija",
    NO_OF_CURRENT_ALARMS:"Število trenutnih alarmov",
    NO_OF_CURRENT_WARNINGS:"Število trenutnih opozoril",
    WEATHER:"Vreme",
    BOXES_WORK_HOURS_COUNTERS:"Delovne ure pralnih mest",
    BOX_TOTAL_HOURS:"Skupno število ur",
    BOX_SERVICE_HOURS:"Skupno število ur (servis)",
    BOX_COUNTER_HOURS:"ure",
    ALARMS_AND_WARNINGS:"Alarmi in opozorila",
    FILTER_AND_BOILER:"Filter in grelnik vode",
    FILTER_TOTAL_DAYS:"Delovni dnevi filterja",
    BOILER_TOTAL_DAYS:"Delovni dnevi grelnika vode",
    DAYS_UNIT:"dni",
    SOFTENER:"Mehčalec",
    MANUAL_COLD_DRAIN:"Ročni zimski izpust",
    EL_COLD:"El. zimski",
    DRAIN:"izpust",
    TAP:"pipa",
    WASTE:"Odpad",
    OSMOSIS:"osmoza",
    DEMI_WATER:"Demineralizirana voda",
    EL_RINSE:"El. m. izpiranja",
    BOILER:"Grelnik vode",
    EL_WAX:"El. m. voska",
    FLOOR_HEATING:"Talno gretje",
    DOSER_TANK:"Dozirna posoda",
    EL_WASH:"El. m. pranja",
    DETERGENT:"Detergent",
    VIBRATOR:"Vibrator",
    UPDATE_FACILITY_SETTINGS:"Posodobi nastavitve",
    GENERAL_SETTINGS:"Splošne nastavitve",
    LIGHTS:"Luči",
    GROUPS:"Skupine",
    ANTI_FREEZE:"Proti zmrzovanje",
    AUTO:"Automatsko",
    MANUAL:"Ročno",
    ON:"Vključeno",
    OFF:"Izključeno",
    TEMPERATURE:"Temperatura",
    UPDATE_DEVICE:"Posodobi nastavitve pralnice",
    BOX_CLEAN_HOURS:"Števec delovnih ur (čiščenje pr. mest)",
    GROUP_COUNTERS:"Števci skupin",
    RESET:"Ponastavi",
    CASH_COUNT:"Števec kovancev",
    COINS_COUNT:"Števec žetonov",
    EUROKEY_COUNT:"Števec evro ključa",
    DOSER_WORK:"Delovni čas dozirnika (sek.)",
    DOSER_PAUSE:"Čas pavze dozirnika (sek.)",
    DELAY_BFV:"Zamuda BFV (ms)",
    DELAY_6M1:"Zamuda 6M1 (ms)",
    DELAY_LPS:"Zamuda LPS (ms)",
    RESET_CASH_COUNT_ALL:"Ponastavitev vseh števcev kovancev",
    RESET_COINS_COUNT_ALL:"Ponastavitev vseh števcev žetonov",
    RESET_EUROKEY_COUNT_ALL:"Ponastavitev vseh števcev evro ključa",
    FACILITY_DETAILS:"Podrobnosti pralnice",
    FACILITY_NAME:"Ime pralnice",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Uspešno ste naložilii sliko.",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Uspešno ste spremenili podatke.",
    CONNECTED:"povezan",
    DISCONNECTED:"Prekinjena povezava",
    OFFLINE:"Brez povezave",
    MESSAGES_FILTER:"Filter sporočil",
    FACILITY:"Pralnica",
    APPLY:"Uporabi",
    TIME:"Čas",
    LOCATION:"Lokacija",
    ACKNOWLEDGED:"Sprejeto",
    FILTERED_MESSAGES:"Filtrirana sporočila",
    ACK:"Sprejeto",
    NOT_ACK:"Ni sprejeto",
    ALL:"Vsi",
    ALL_FACILITIES:"Vse pralnice",
    ENTER_DATE_PLACEHOLDER:"Vnesite datum",
    OP_NESTANAK_NAPONA:"Manjka napetost na indikatorju faze 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"Napaka na črpalki MZS",
    OP_UPR_NAPON_24VAC_GRE:"Krmilna napetost 24VAC napaka -5F1.1'",
    OP_MIN_NIVO_PITKA_VODA:"Prazen rezervoar za pitno vodo.",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Črpalka pitne vode, napaka v motorskem zaščitnem stikalu.",
    OP_MIN_NIVO_OMEKS_VODE:"Prazen rezervoar za mehko vodo.",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Črpalka mehke vode, napaka v motorskem zaščitnem stikalu.",
    OP_MIN_NIVO_DEMIN_VODE:"Prazen rezervoar za demineralizirano vodo.",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Črpalka demineralizirane vode, napaka v motorskem zaščitnem stikalu.",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Črpalka za reverzno osmozo, napaka v motorskem zaščitnem stikalu.",
    OP_BOJLER_GRESKA_MZS:"Napaka na grelniku vode.",
    OP_CRPKA_PRASKA_GRE_MZS:"Črpalka za prašek, napaka v motorskem zaščitnem stikalu.",
    OP_DOZATOR_PRASKA_GRE_MZS:"Napaka na dozirniku praška.",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Napaka na vibratorju za doziranje praška.",
    OP_MIN_PRASAK_TON_ALARM:"Prazen rezervoar za prašek.",
    OP_USIS_KOV_TURBINA_GRESKA:"Turbina za izsesavanje kovancev, napaka v motorskem zaščitnem stikalu.",
    OP_FILTER_VODE_ZACEPLJEN:"Zamašen filter vode",
    OP_VISKTL_RESET_SATI_RADA:"Servis visokotlačne črpalke",
    OPW_VISKTL_RESET_SATI_RADA:"Servis visokotlačne črpalke",
    OP_FILTER_DANI_RADA:"Servis filtra",
    OP_BOJLER_DANI_RADA:"Servis grelnika vode",
    OPW_ALARM_VISOKOTL_PUMPA:"Alarm za visokotlačno pumpo",
    OPW_ALARM_FILTER_SERVIS:"Alarm za servis filtra",
    OPW_ALARM_BOJLER_SERVIS:"Alarm za servis grelnika vode",
    HAS_MEMBERS:"Izbrana skupina ima člane in jih ni mogoče izbrisati. Člane je treba najprej izbrisati.",
    PERIODIC_SUMMARY_FOR:"PERIODIČNO SKUPNO POROČILO ZA",
    PERIODIC_SUMMARY_REPORTS:"Periodična skupna poročila",
    DATE_RANGE:"Časovno obdobje",
    FINANCIAL_REPORT:"Finančno poročilo",
    GROSS_INCOME:"Bruto dohodek",
    GROSS_INCOME_SUM:"Vsota bruto dohodka",
    COMMISSION_FEE:"Provizija",
    NET_INCOME:"Neto dohodek (za plačilo)",
    COMMISSION_FEE_DETAILS:"Vključuje bančne/PayPal provizije za transakcije ali provizije za storitev SMS.",
    LOYALTY_CREDITS_REPORT:"Poročilo programa zvestobe",
    LOYALTY_GIVEN:"Dani lokalni žetoni",
    LOYALTY_USED:"Porabljen lokalni žetoni",
    LOYALTY_SOLD:"Lokalni žetoni naloženi",
    LOYALTY_TOTAL:"Skupno",
    LOYALTY_CURRENT_MONTH:"Tekoči mesec",
    SOMETHING_WENT_WRONG:"Ups, prišlo je do napake :-(",
    MISSING_PAGE:"Oprostite, nismo mogli najti te strani.",
    TRY_AGAIN:"Poskusite ponovno.",
    DEFAULT_ERROR_NAME:"Prišlo je do neznane napake.",
    DEFAULT_ERROR_DESCRIPTION:"Prosimo, poskusite ponovno.",
    MY_ACCOUNT_DETAILS:"Podrobnosti uporabniškega računa",
    SAVE_CHANGES:"Shrani spremembe",
    USERNAME:"Uporabniško ime",
    FIRST_NAME:"Ime",
    LAST_NAME:"Priimek",
    USER_ROLE:"Uporabniška vloga",
    OLD_PASSWORD:"Staro geslo",
    NEW_PASSWORD:"Novo geslo",
    OLD_PASSWORD_REQUIRED:"Polje za staro geslo je obvezno.",
    NEW_PASSWORD_REQUIRED:"Polje za novo geslo je obvezno.",
    NEW_PASSWORD_REPEAT:"Polje za ponovitev novega gesla je obvezno.",
    NEW_PASSWORD_NOT_MATCH:"Staro in novo geslo nista enaka.",
    PASSWORD_DIFFERENT_VALIDATION:"Novo geslo mora biti drugačno od starega.",
    PASSWORD_MIN_CHAR:"Vaše geslo mora imeti vsaj 8 znakov.",
    PASSWORD_MAX_CHAR:"Vaše geslo ne sme imeti več kot 32 znakov.",
    PASSWORD_PATTERN_VALIDATION:"Geslo mora vsebovati vsaj eno številko, eno malo in eno veliko črko.",
    ACCOUNT_MANAGEMENT:"Vodenje računa",
    NOT_ACTIVE:"Neaktiven",
    ASSIGN_ROLE:"Dodeli vlogo",
    UPDATE:"Posodobi",
    ADD_NEW_ACCOUNT:"Dodajanje novega računa",
    EMAIL_REQUIRED:"Elektronski naslov je obvezen.",
    EMAIL_NOT_VALID:"Elektronski naslov ni veljaven.",
    ADD_NEW_USER_TEXT:"Na vpisan elektronski naslov vam bomo poslali elektronsko sporočilo z bližnjico za aktiviranje.",
    UPDATE_USER_NOTIFICATION:"Uspešno ste posodobili podatke.",
    CHANGED_PASSWORD_NOTIFICATION:"Uspešno ste spremenili geslo.",
    UPDATE_USER_GROUP_NOTIFICATION:"Uspešno ste spremenili ime skupine.",
    CREATE_USER_GROUP_NOTIFICATION:"Uspešno ste ustvarili skupino.",
    DETELE_USER_GROUP_NOTIFICATION:"Uspešno ste izbrisali skupino.",
    EMPTY_GROUP_LIST_MSG:"Ni ustvarjenih skupin. Začnite z ustvarjanjem skupine",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Uspešno ste izbrisali uporabnika iz skupine.",
    ADD_USER_TO_GROUP_NOTIFICATION:"Uspešno ste dodali uporabnika v skupino.",
    ADD_USER_NOTIFICATION:"Uspešno ste dodali novega uporabnika.",
    DELETE_USER_NOTIFICATION:"Uspešno ste izbrisali uporabnika.",
    RESEND_USER_VERIFICATION_EMAIL:"Uspešno ste znova poslali potrditveno e-pošto",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Prosimo, da za ustvarjanje nove uporabniške skupine vnesete ime skupine.",
    DELETE_USER:"Brisanje uporabnika",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Ali ste prepričani, da želite izbrisati uporabnika iz skupine?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Spoštovani R2W uporabnik, če nas boste obiskali v času akcije tega meseca, boste na vaš račun prejeli dodatni bonus.",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Pravilo oglasa glede na število obiskov",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Pravilo oglasa glede na porabljene žetone",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Pravilo oglasa glede na dneve v tednu",
    REMOVE_CAMPAIGN_RULE_TITLE:"Brisanje pravila oglasa.",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Ali ste prepričani, da želite izbrisati pravilo oglasa?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Uspešno ste ustvarili novo pravilo oglasa.",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Uspešno ste aktivirali oglas.",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Ni ustvarjenih oglasov. Začnite z ustvarjanjem oglasa",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Uspešno ste poslali sporočilo.",
    COMPANY_ACCOUNTS:"Računi podjetja",
    BUSSINESS_INVOICES_LIST:"Moji B2B računi",
    LOCALE_TOKEN:"Lokalni žeton",
    R2W:"Svetovni R2W žeton",
    START_MONTH:"Začetni mesec",
    END_MONTH:"Konec meseca",
    TOKEN_TYPE:"Vrsta žetonov",
    TOKEN_NUMBER:"Številka žetona",
    NOTHING_TO_DISPLAY:"* Nič za prikaz",
    CREATE_INVOICE:"Ustvari račun",
    INVOICE:"Račun",
    INVOICES:"Računi",
    EDIT_INVOICE:"Uredi račun",
    UPDATE_INVOICE_NOTIFICATION:"Uspešno ste spremenili status računa v 'v teku'",
    CURRENT_CHARGES:"Stroški za tekoče obdobje",
    PAYMENTS_ON_HOLD:"Računi v obdelavi",
    FOR_INVOICING:"Za izdajo",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Poskušate preklicati izdajo računa.",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Ali ste prepričani, da želite preklicati račun?",
    INVOICING_NOTIFICATION_HEADER:"Poskušate poslati račun.",
    INVOICING_NOTIFICATION_TEXT:"Ali ste prepričani, da želite poslati račun?",
    SENT_INVOICE_NOTIFICATION:"Uspešno ste poslali račun",
    CANCELED_INVOICE_NOTIFICATION:"Uspešno ste preklicali račun",
    INVOICE_DESCRIPTION_TEXT:"Račun za",
    INVOICE_STATE:"Status računa",
    INVOICE_NUMBER:"Številka računa",
    INVOICE_TOTAL:"Skupno",
    SELECT_YEAR:"Izberi leto",
    DOWNLOAD:"Prenesi PDF",
    INVOICE_NUMBER_HEADER:"Nameravate poslati račun s številko",
    INVOICE_PAYMENT_CONFIRMATION:"Nameravate potrditi plačilo računa s številko",
    INSERT_INVOICE_NUMBER:"-- Vnesi številko računa",
    INVOICED_WARNING:"Elektronsko sporočilo ni poslano. Prosimo, počakajte ...",
    SEND_INVOICE:"Pošlji",
    INVOICE_ALL:"Vsi",
    INVOICE_FROM_R2W:"Od R2W",
    INVOICE_TO_R2W:"Za R2W",
    PAYMENT_REQUEST:"Zahteva za plačilo",
    PAYMENT_REQUEST_STATE:"Stanje zahteve za plačilo",
    PAYMENT_REQUEST_NUMBER:"Številka zahtevka za plačilo",
    FOR_PAYMENT_REQUEST:"Za zahtevek za plačilo",
    PAYMENT_REQUEST_ON_HOLD:"Zahteva za plačilo v obdelavi",
    DOWNLOAD_INVOICE:"Prenesite račun",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Kliknite za možnosti prenosa",
    B2B_SPEC:"B2B Specifikacija",
    B2C_SPEC:"B2C Specifikacija",
    DOWNLOAD_PAYMENT_REQUEST:"Prenesite zahtevo za plačilo",
    LOYALTY_PREVIEW:"Pregled oglasa",
    ACTIVATED:"Aktiven",
    RUNNING:"Traja",
    NOT_ACTIVATED:"Ni aktiven",
    FINISHED:"Končan",
    DEPRECATED:"Zastarel",
    UPCOMING:"Prihajajoč",
    NONE:"Manjka",
    STARTED:"Začet",
    ENDS:"Se končuje",
    DEDICATED:"Namenjen",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Poskušate aktivirati",
    CAMPAIGN:"oglas",
    SEND_MESSAGE_NOTIFICATION:"Ali želite poslati sporočilo vsem uporabniškim skupinam",
    DIVISIBLE_TO_NUMBER:"Številka mora biti deljiva s ",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Vrsta naprave",
    LISTENER:"Majhni stroji",
    BRIDGE:"Pralna mesta",
    WASH_BOXES:"Pralna mesta",
    VACUUMS:"Sesalniki",
    SAVE_NEWS:"Shrani novico",
    CREATE_NEW_NEWS:"Ustvari novo novico",
    HISTORY_OF_ALL_NEWS:"Zgodovina vseh novic",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Vpiši ime pralnice.",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Dodaj novo pralnico.",
    NEWS_TEXT:"Besedilo novice",
    NEWS_TITLE:"Naslov novice",
    DELETE_NEWS_CONFIRMATION:"želite izbrisati novico?",
    NEWS_DELETE_NOTIFICATION:"Uspešno ste izbrisali novico.",
    NEWS_SAVE_NOTIFICATION:"Uspešno ste shranili novico.",
    NEWS_CREATION_DATE:"Datum nastanka",
    NO_TITLE:"Ni naslova",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Besedilo novice ne sme biti daljše od 255 znakov.",
    NEWS_TEXT_REQUIRED_VALIDATION:"Besedilo novice je obvezno.",
    NEWS_TITLE_REQUIRED_VALIDATION:"Naslov novice je obvezen.",
    DEACTIVATE:"Onemogoči",
    ASIDE_MENU_LOCAL_TOKENS:"Lokalni žetoni",
    CREATE_NEW_LOCAL_TOKENS:"Izdaja novih lokalnih žetonov",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Vnesite elektronski naslov uporabnika in število žetonov, ki mu jih želite izdati.",
    CREATE_TOKENS:"Izdaj žetone",
    MINIMUM_ONE_TOKEN:"Vrednost mora biti večja od 0.",
    CUSTOMER_EMAIL:"Uporabnikov elektronski naslov",
    AMOUNT_OF_TOKENS:"Število žetonov",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Uspešno ste izdali lokalne žetone:",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Prišlo je do napake pri izdaji žetonov. Prosimo, preverite uporabnikov elektronski naslov in poskusite ponovno.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Pregled izdanih lokalnih žetonov",
    ISSUED_AT:"Čas izdaje",
    ISSUED_BY:"Izdal",
    CODE:"Koda",
    REDEEMED_BY:"Izkoristil",
    REDEEMED_AT:"Čas",
    ASIDE_MENU_VOUCHERS:"Kuponi",
    PRINT:"Tiskanje",
    VOUCHERS_OVERVIEW:"Pregled kuponov",
    CREATE_NEW_VOUCHERS:"Ustvari nove kupone",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Ustvari novo serijo kuponov z vnosom števila žetonov na kupon, količine kuponov v seriji in predpone kode za serijo",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Število žetonov na kupon",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Dovoljeno je dodati med 1 in 100 žetoni na kupon.",
    NUMBER_OF_NEW_VOUCHERS:"Količina kuponov v seriji",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"Dovoljeno je ustvariti med 1 in {{size}} kuponov v eni seriji.",
    NEW_VOUCHERS_PREFIX:"Predpona kode kuponov v seriji",
    VALIDATION_VOUCHER_PREFIX:"Predpona kode mora biti natanko 4 znake (velike črke in / ali številke)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Prišlo je do napake pri ustvarjanju novih kuponov. Prosimo, poskusite ponovno ali kontaktirajte tehnično pomoč.",
    CREATE_VOUCHERS:"Ustvari serijo kuponov",
    CREATING_VOUCHERS_SUCCESS:"Nova serija kuponov je uspešno ustvarjena",
    PRINT_NEW_VOUCHERS:"Natisni kupone",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Vnesite serijsko številko kupona, celo kodo ali del kode kupona za tisk ustreznih kuponov.",
    PRINT_VOUCHERS_PREFIX:"Predpona kode (serije) kuponov",
    NO_VOUCHERS_FOR_PRINT:"Ni kuponov za tisk z vneseno predpono kode.",
    PRINT_VOUCHERS:"Natisni kupone",
    VALIDATION_VOUCHER_CODE_FILTER:"Iskalni izraz za kupon mora biti sestavljen iz velikih črk in številk",
    FILTER_VOUCHERS_BY_CODE:"Filter kuponov po kodi",
    FILTER_VOUCHERS:"Išči kupone",
    WASH_BOX:"Boks za pranje",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Skupaj porabljenih digitalnih žetonov",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Skupaj prodanih lokalnih žetonov po datumu",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Skupaj porabljeni lokalni žetoni po datumu",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Skupaj danih lokalnih žetonov po datumu",
    LOCAL_TOKEN:"Lokalni žeton",
    GIVEN_TOKEN:"Dani na lokalni žetoni",
    SOLD_TOKEN:"Prodani lokalni žetoni",
    SMALL_MACHINES:"Majhni stroji",
    R2W_Listener:"Listener",
    HHANLE_DEVICE:"HHanle - Boks za pranje",
    CODE_PREFIX_EXIST:"Predpona kode že obstaja",
    CODE_PREFIX_EXIST_TEXT:"S to predpono kode ne morete ustvariti novega kupona. Izberite drugo.",
    MIN_FOUR_VALIDATION:"Natanko 4 znake",
    ALL_INFORMATION_1:"Vse informacije o",
    ALL_INFORMATION_2:"bodo izgubljeni",
    ASIDE_MENU_TRANSACTIONS:"Transakcije",
    EXPENSES:"Stroški",
    TOPUPS:"Nakup žetonov",
    EXPENSES_LIST:"Seznam stroškov",
    USER_EMAIL:"Uporabniški e-poštni naslov",
    COMPANY_NAME:"Ime podjetja",
    TOPUPS_LIST:"Seznam kupljenih žetonov",
    CONSUMER:"Stranka",
    SYSTEM_ADMIN:"Sistemski administrator",
    MERCHANT_ADMIN:"Skrbnik administrator",
    COMPANY_ADMIN:"Skrbnik podjetja",
    FACILITY_ADMIN:"Administator pralnice",
    SUBSCRIBER:"Naročnik",
    CONFIGURATOR:"Konfigurator",
    SETUP_UNIT_SERIAL_NO:"Serijska številka",
    SETUP_UNIT_MATERIAL_NO:"Št. materiala",
    SETUP_UNIT_WEBAPI_VERSION:"Različica WebApi",
    TOTAL_TURNOVER:"Promet pralnice",
    AVAILABILITY_ALL:"razpoložljivost",
    AVAILIBILITY:"Razpoložljivost pralnih mest:",
    AVAILABILITY_VACUUMS:"Razpoložljivost sesalcev:",
    WASH_BOX_INFO:"Informacije pralnega mesta",
    VACUUM_CLEANER_INFO:"Informacije sesalcev",
    BREAD_CRUMBS_SERVICE:"Servis",
    HOLIDAYS:"Počitnice",
    HOLIDAY:"Praznik",
    LIGHTS_ON:"Luči/on",
    LIGHTS_OFF:"Luči/off",
    WASH_BOXES_ON:"Pralno mesto/on",
    WASH_BOXES_OFF:"Pralno mesto/off",
    VACUUMS_ON:"Sesalec/on",
    VACUUMS_OFF:"Sesalec/off",
    TURNOVER:"Promet",
    TURNOVER_MANUAL_WASH_UNIT:"Promet ročno",
    STATUS_BAY_RUN_TIME:"Skupni delovni čas pralnega boksa",
    STATUS_BAY_PROGRAM_NAME:"Ime programa",
    STATUS_BAY_CREDIT:"Kredit pralni box",
    CLOUD_KREDIT:"Oblak kredit",
    STATUS_VACUUM_RUN_TIME:"Skupni delovni čas sesanja",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Avtopralnica servis, program pralnih mest in podatki o trenutnih podatkih o napakah",
    UNAVAILABLE:"Enota ni na voljo",
    SHOW_HIDE_TABLE:"Prikaži/skrij tabelo delovnih ur",
    PROGRAM_NAME:"Ime programa",
    PROGRAM_COUNTER:"Števec programa",
    NO_NAME:"Referenca nima imena",
    COUNTER_SERVICE_DATA:"Servisni podatki",
    NEED_SERVICE:"Potreben servis",
    PROGRAM_DATA:"Podatki o programu pralnih mest",
    CURRENT_FAULT_DATA:"Trenutni podatki o napakah",
    REFERENCE_DUE:"Rok",
    REFERENCE_SECONDS:"Sekunde",
    REFERENCE_NAME:"Ime dela",
    WASHBOX_NAME:"Ime pralnega mesta",
    FAULT_NAME:"Ime napake",
    FAULT_NUMBER:"Številka napake",
    CURRENT_FAULT_COUNT:"Aktivne napake",
    DEVICE_NOT_INSTALLED:"Naprava ni nameščena",
    STATUS_READY:"Stanje pripravljenosti",
    STATUS_ERROR:"Stanje napake",
    CONNECTION_ERROR:"Ni povezave",
    UNKNOWN_RESET:"Napaka programske opreme",
    SOFTWARE_RESET:"Napaka programske opreme",
    EXTERNAL_PIN_RESET:" Napaka programske opreme",
    RESTART_OR_BROWNOUT_OCCURRED:"Napaka programske opreme",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Napaka strojne opreme",
    COULD_NOT_SIMULATE_COIN:"Napaka strojne opreme",
    ERROR_SETTING_INHIBIT_MODE:"Napaka strojne opreme",
    OFFLINE_DEVICE:"Avtopralnica brez povezave",
    TARIFFS:"Tarife",
    DAY:"Dan",
    NIGHT:"Noč",
    VOUCHER_CODE:"Koda bona",
    DISMISS_ALARM:"Ponastaviti alarm?",
    ALARM_ACTIVE:"Aktivni alarmi",
    NO_ALARM_ACTIVE:"Ni aktivnih alarmov",
    ALARM_HISTORY:"Zgodovina alarmov",
    MANAGING_TOKENS:"Upravljanje žetonov",
    EXPIRATION_DATE:"Rok trajanja",
    EXTEND_TOKEN_DATE:"Podaljšajte datum poteka veljavnosti žetona za",
    DELETE_TOKENS_FOR:"Izbriši žetone za",
    PUMP_TYPE:"Vrsta črpalke",
    TURN_OFF_DEVICE:"Stanje naprave",
    OPERATION_DATA:"Podatki o delovanju",
    PUMP_DATA:"Podatki o črpalki",
    PUMP_NAME:"Ime črpalke",
    POINT_NAME:"Ime točke",
    CHANGER_INCOME:"Skupni dohodek menjalca po datumu",
    SELECTED_OPEN:"Odprto ob izbranem delovnem času",
    ALWAYS_OPEN:"Vedno odprto (24/7)",
    CLOSED:"Zaprto",
    CLOSED_24:"Zaprto 24 ur",
    OPENED_24:"Odprto 24 ur",
    MON:"Ponedeljek",
    TUE:"Torek",
    WED:"Sreda",
    THU:"Četrtek",
    FRI:"Petek",
    SAT:"Sobota ",
    SUN:"Nedelja",
    PRICING:"Cenitev",
    PRICE:"Cena",
    VALIDITY:"Veljavnost",
    TOKEN_PACKAGES:"Paketi žetonov",
    SINGLE_WASH:"Enkratno pranje",
    FACILITY_WORKING_HOURS:"Nastavite delovni čas za izbrani objekt",
    WORKING_HOURS_ALWAYS_OPEN:"Vedno odprto",
    WORKING_HOURS_ALWAYS_CLOSE:"Zaprl operater",
    WORKING_HOURS_CUSTOM:"Nastavite delovni čas",
    KARCHER_ERROR_CODE:"Opozorilna koda napake",
    KARCHER_ERROR_MESSAGE_1:"Electronic outlets overloaded",
    KARCHER_ERROR_MESSAGE_2:"The oil separator must be emptied",
    KARCHER_ERROR_MESSAGE_4:"Dimming sensor defective",
    KARCHER_ERROR_MESSAGE_5:"Protective motor switch on high pressure pumps was triggered",
    KARCHER_ERROR_MESSAGE_6:"Connection to RDS defective",
    KARCHER_ERROR_MESSAGE_7:"The pressure switch for air on the compressor does not report any",
    KARCHER_ERROR_MESSAGE_8:"Cause: no connection to the electronics 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"No connection to pump electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_11:"Electronic outlets at washing station 1 overloaded",
    KARCHER_ERROR_MESSAGE_12:"Current pickup of high pressure pump at washing station 1 too high",
    KARCHER_ERROR_MESSAGE_13:"Current pickup of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_14:"Contact of high pressure pump at washing station 1 stuck",
    KARCHER_ERROR_MESSAGE_15:"Semiload valve at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor BUFFER TANK EMPTY activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor BUFFER CONTAINER EMPTY and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor RO PUMP ON and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    ORGANIZATION:"Organizacija",
    CREATE_ORGANIZATION:"Ustvari organizacijo",
    CREATE_ORGANIZATION_AS:"Ustvarite organizacijo kot otroka za",
    DELETE_ORGANIZATION:"Izbriši organizacijo",
    EDIT_ORGANIZATION:"Uredi organizacijo",
    SUPPORTED_ORG_NAME:"Podprta organizacija",
    SUPPORTED_ORG_TYPE:"Podprta vrsta",
    ORG_NAME:"Ime",
    ORG_TYPE:"Vrsta",
    SET_ORG_TITLE:"Nastavite otroško organizacijo",
    SET_SUPPORTED_ORG_TITLE:"Nastavite podprto podrejeno organizacijo",
    SAVE_ORGANIZATION:"Shranite organizacijo",
    SELECT_ORGANIZATION_TYPE:"Izberite vrsto organizacije",
    SELECT_ORGANIZATION_SELECTOR:"Izberite",
    SELECT_SUPPORTED_ORGANIZATION:"Izberite podprto organizacijo",
    ORGANIZATION_DELETED:"Organizacija je bila uspešno izbrisana",
    ORGANIZATION_SAVED:"Organizacija uspešno shranjena",
    ORGANIZATION_UPDATED:"Organizacija je bila uspešno posodobljena",
    ALERTS:"Opozorila",
    DEVICE_STATUS:"Stanje naprave",
    SITE_DETAILS:"Podrobnosti lokacije",
    ALARM_STATUS:"Stanje opozorila",
    FILTER:"Filtriraj po ...",
    FILTER_BY_ALERT_CENTER:"Filtrirajte po kodi, imenu ali opisu",
    TOTAL_ALARM:"Skupaj",
    LOW_ALARM:"Dogodek",
    MEDIUM_ALARM:"Motnja",
    HIGH_ALARM:"Kritična napaka",
    NO_FACILITIES_NEARBY:"V bližini ni objektov",
    GRAY_MAP:"Zemljevid v sivem slogu",
    READY:"Pripravljen",
    WARNING:"Motnja",
    ERROR:"Napaka",
    SITE_NAME:"Ime lokacije",
    ACCOUNTS_INFO:"Podatki o računu",
    USER_ORGANIZATION:"Organizacija uporabnikov",
    ADD_USER_ORGANIZATION:"Dodajte novega uporabnika organizacije",
    EDIT_USER_ORGANIZATION:"Uredite uporabnike organizacije",
    SELECT_ROLE:"Izberite vlogo",
    SELECT_ORGANIZATION:"Izberite organizacijo",
    SELECT_USER:"Izberite uporabnika",
    USER_FOR_ORGANIZATION_CREATED:"Nov uporabnik je bil uspešno ustvarjen",
    SELECT_REGION:"Izberite regijo",
    SELECT_LANGUAGE:"Izberi jezik",
    LOADING_DATA:"Nalaganje podatkov, počakajte ...",
    ADMINISTRATOR:"Administrator",
    TECHNICAL_SUPPORT:"Tehnična podpora",
    CONTROLLER:"Krmilnik",
    EDIT_ORGANIZATION_USER:"Uredite uporabnike organizacije",
    DELETE_ORGANIZATION_USER:"Izbrišite uporabnike organizacije",
    USER_UPDATED:"Uporabnik uspešno posodobljen",
    USER_CREATED:"Uporabnik uspešno ustvarjen",
    ADDRESS:"Naslov",
    SUBSCRIPTIONS:"Naročnine",
    RESOLVED_STATUS:"Rešeno",
    NOT_RESOLVED_STATUS:"Ni rešeno",
    ALERT_NAME:"Ime opozorila",
    ALERT_DESCRIPTION:"Opis opozorila",
    ALERT_CODE:"Opozorilna koda",
    ALERT_TYPE:"Vrsta opozorila",
    UNSUBSCRIBE:"Opozorilo o odjavi",
    SUBSCRIBE:"Opozorilo za naročanje",
    ALARM_SUBSCRIBED:"Uspešno naročen",
    UNSUBSCRIBED_CONFIRM:"Odjava?",
    ALARM_UNSUBSCRIBED:"Uspešno odjavljen",
    ASIDE_MENU_CASHLESS_SALES:"Brezgotovinska prodaja",
    FILTERED_CASHLESS_PAYMENTS:"Filtrirana brezgotovinska plačila",
    REFUND_DIALOG_TITLE:"Vračilo transakcije?",
    REFUND_DIALOG_SUBTITLE:"Znesek je lahko manjši ali enak znesku transakcije",
    REFUND:"Povračilo",
    INPUT_NOT_VALID:"Vnos ni veljaven",
    REFUND_SUCCESSFULLY:"Vračilo za izbrano plačilo je bilo uspešno izvedeno",
    USER:"Uporabnik",
    TRANSACTION_ID:"PSP referenca",
    DEVICE_ID:"ID naprave",
    NET_AMOUNT:"Neto znesek",
    REPORT_NAME:"Ime poročila",
    TIME_FRAME:"Časovni okvir",
    SUB_POINT:"Izberite podtočko",
    SUB_POINT_LIST_NOT_EXIST:"Seznam podtočk ne obstaja za izbrano pralnico",
    FACILITY_TYPE:"Vrsta objekta",
    MACHINE_NAME:"Ime stroja",
    WASH_FACILITY_DETAILS:"Podrobnosti o pralnici",
    WASH_BAY_DETAILS:"Podrobnosti o pralnem mestu",
    DEVICES_INFO:"Seznam naprav",
    OPERATION_TIME_INFO:"Čas delovanja",
    OPERATION_TIME_VACUUM_INFO:"Čas delovanja za sesalnike",
    OPERATION_TIME_ILLUMINATION_INFO:"Čas delovanja za osvetlitev",
    AVAILABLE_TITLE:"Na voljo",
    UNAVAILABLE_TITLE:"Ni na voljo",
    CURRENT_PROGRAM:"Trenutni program",
    CREDITS:"Krediti",
    DEVICE_NAME:"Ime naprave",
    ACTIVE_ALARMS:"Aktivna opozorila",
    ALL_DAY:"Ves dan",
    OPERATING_TIME_WASH_FACILITY:"Samopostrežni pralni sistem",
    OPERATING_TIME_VACUUMS:"Sesalniki",
    OPERATING_TIME_ILLUMINATION:"Osvetlitev",
    OPERATION_COUNTERS:"Števci operacij",
    EDIT:"Uredi",
    WASHING_PROGRAMS:"Programi pranja",
    INFO:"Dogodek",
    STATISTIC:"Statistika",
    ROLLOVER_DOSING:"Odmerjanje",
    ROLLOVER_SPEED:"Hitrosti",
    ROLLOVER_RESETS:"Daljinska ponastavitev pri Rollover",
    ROLLOVER_RESETS_INFO:"Ponastavitev na daljavo mora biti v skladu z lokalnimi predpisi. Pomembno: Pred ponastavitvijo se prepričajte, da je rollover prazen.",
    RESET_ROLLOVER:"Ponastavi Rollover",
    OPEN_DOOR_ROLLOVER:"Odprto",
    ROLLOVER_OPEN_DOOR_INFO:"Odprite vrata pralnice. Bodi previden.",
    ROLLOVER_OPEN_DOOR:"Odpri vrata",
    APPLY_DOSING_CHANGES:"Uporabite spremembe odmerjanja",
    APPLY_SPEED_CHANGES:"Uporabi spremembe hitrosti",
    ACTUATION_SUCCESS:"Prošnja poslana",
    REMAINING_TIME:"Preostali čas",
    OPEN_24H:"Odprto 24 ur",
    CLOSE_24H:"Zapro 24 ur",
    VALIDATION_OPERATION_TIME:"Oblika ni pravilna. Uporabite hh:mm",
    ROLLOVER:"Rollover",
    UPDATE_WASHING_PROGRAM:"Posodobite program pranja",
    UPDATE_ACTUATORS:"Posodobite aktuatorje",
    OPEN_ROLOVER_DOOR_TITLE:"Želite odpreti vrata Rollovera?",
    OPEN_ROLOVER_DOOR_CONTENT:"Ste prepričani, da želite odpreti vrata?",
    RESET_ROLOVER_TITLE:"Želite ponastaviti Rollover?",
    RESET_ROLOVER_CONTENT:"Ali ste prepričani, da želite ponastaviti Rollover?",
    G0:"{{brand === 'r2w' ? 'Pralno mesto 0' : 'Pralno mesto 1'}}",
    G1:"{{brand === 'r2w' ? 'Pralno mesto 1' : 'Pralno mesto 2'}}",
    G2:"{{brand === 'r2w' ? 'Pralno mesto 2' : 'Pralno mesto 3'}}",
    G3:"{{brand === 'r2w' ? 'Pralno mesto 3' : 'Pralno mesto 4'}}",
    G4:"{{brand === 'r2w' ? 'Pralno mesto 4' : 'Pralno mesto 5'}}",
    G5:"{{brand === 'r2w' ? 'Pralno mesto 5' : 'Pralno mesto 6'}}",
    G6:"{{brand === 'r2w' ? 'Pralno mesto 6' : 'Pralno mesto 7'}}",
    G7:"{{brand === 'r2w' ? 'Pralno mesto 7' : 'Pralno mesto 8'}}",
    G8:"{{brand === 'r2w' ? 'Pralno mesto 8' : 'Pralno mesto 9'}}",
    G9:"{{brand === 'r2w' ? 'Pralno mesto 9' : 'Pralno mesto 10'}}",
    G10:"{{brand === 'r2w' ? 'Pralno mesto 10' : 'Pralno mesto 11'}}",
    U0:"{{brand === 'r2w' ? 'Sesalnik 0' : 'Sesalnik 1'}}",
    U1:"{{brand === 'r2w' ? 'Sesalnik 1' : 'Sesalnik 2'}}",
    U2:"{{brand === 'r2w' ? 'Sesalnik 2' : 'Sesalnik 3'}}",
    U3:"{{brand === 'r2w' ? 'Sesalnik 3' : 'Sesalnik 4'}}",
    U4:"{{brand === 'r2w' ? 'Sesalnik 4' : 'Sesalnik 5'}}",
    U5:"{{brand === 'r2w' ? 'Sesalnik 5' : 'Sesalnik 6'}}",
    U6:"{{brand === 'r2w' ? 'Sesalnik 6' : 'Sesalnik 7'}}",
    U7:"{{brand === 'r2w' ? 'Sesalnik 7' : 'Sesalnik 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Poročilo centra za opozorila, ki ga je ustvarilo izbrana lokacija z nadzorne plošče",
    ALERT_CENTER_TITLE_BY_FACILITY:"Poročilo centra za obveščanje, ki ga je ustvaril izbrani objekt z nadzorne plošče",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Poročilo centra za obveščanje",
    ERROR_MESSAGE_403:"Nimate privilegija za uporabo tega klica API. Koda napake: 403",
    LAST_ACTIVE_PROGRAM:"Aktivni program / Zadnji aktivni program",
    PROGRAM_ID:"Številka programa",
    PROGRAM_PRICE:"Cena programa",
    NORMAL_CHEMICAL_LEVEL:"V redu",
    LOW_CHEMICAL_LEVEL:"Potrebno ponovno polnjenje",
    EMPTY_CHEMICAL_LEVEL:"Prazno",
    CHEMICAL_LEVEL:"Indikacija nivoja detergentov (%)",
    ROLLOVER_STATUS:"Stanje Rollowera",
    ROLLOVER_STATUS_CODE_0:"Pranje trenutno ne deluje",
    ROLLOVER_STATUS_CODE_1:"Izven delovnega časa",
    ROLLOVER_STATUS_CODE_2:"Dovoljen vstop v program",
    ROLLOVER_STATUS_CODE_3:"Postavite svoje vozilo",
    ROLLOVER_STATUS_CODE_4:"Vozilo naprej",
    ROLLOVER_STATUS_CODE_5:"Vozilo nazaj",
    ROLLOVER_STATUS_CODE_6:"Ustavitev vozila",
    ROLLOVER_STATUS_CODE_7:"Pranje aktivno",
    ROLLOVER_STATUS_CODE_8:"Pranje ustavljeno",
    ROLLOVER_STATUS_CODE_9:"Aktivno pranje (takt)",
    ROLLOVER_STATUS_CODE_10:"Izpeljite z vozilom vzvratno",
    ROLLOVER_STATUS_CODE_11:"Ustavitev v sili",
    ROLLOVER_STATUS_CODE_12:"Izpeljite z vozilom naprej",
    ROLLOVER_STATUS_CODE_13:"Proti zmrzovanju aktivno",
    ROLLOVER_STATUS_CODE_14:"Aktivirano sprednje varnostno stikalo",
    ROLLOVER_STATUS_CODE_15:"Aktivirano varnostno stikalo zadaj",
    ROLLOVER_STATUS_CODE_16:"Aktivirano je varnostno stikalo na sprednji levi strani",
    ROLLOVER_STATUS_CODE_17:"Aktivirano je varnostno stikalo na sprednji desni strani",
    ROLLOVER_STATUS_CODE_18:"Aktivirano je varnostno stikalo na zadnji levi strani",
    ROLLOVER_STATUS_CODE_19:"Aktivirano je varnostno stikalo na desni strani",
    ROLLOVER_STATUS_CODE_20:"Položaj vozila preveč levo",
    ROLLOVER_STATUS_CODE_21:"Položaj vozila preveč desno",
    ROLLOVER_STATUS_CODE_22:"Leva vrata niso zaprta",
    ROLLOVER_STATUS_CODE_23:"Desna vrata niso zaprta",
    ROLLOVER_STATUS_CODE_24:"Zaznan transporter, izbran napačen program pranja",
    ROLLOVER_STATUS_CODE_25:"Senzor hupe",
    ROLLOVER_STATUS_CODE_98:"Ročni / način prilagajanja",
    ROLLOVER_STATUS_CODE_99:"Neznano stanje",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Statusna koda nedefinirana",
    ALARM:"Kritična napaka",
    NO_ALARM:"Ni kritične napake",
    SOFTWARE_VERSION:"Različica programske opreme",
    SOFTWARE_DATE:"Datum programske opreme",
    SITE_ADDRESS:"Naslov lokacije",
    SECONDS:"sekund",
    SERVICE_PART_NAME:"Ime storitve:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Števec obratovanja in storitev",
    OPERATION_COUNTER:"Števec operacij",
    SERVICE_COUNTER:"Števec storitev",
    FAULT_CODE:"Opozorilna koda",
    PRESSURE_TITLE:"Zračni tlak",
    TIME_TITLE:"Trenutni čas",
    COUNTRY_TITLE:"Država",
    CITY_TITLE:"Mesto",
    REGION_TITLE:"Regija",
    SELECT_POINTS_TO_SEARCH:"Izberite točke ...",
    LOGS_HISTORY:"Zgodovina sprememb parametrov",
    ACTUATOR_REFERENCE:"Referenca aktuatorja",
    ACTUATOR_VALUE:"Vrednost aktuatorja",
    POINT_ID:"ID točke",
    VALIDATION_NOT_VALID_RANGE:"Napačen obseg",
    ENABLE_ROLLOVER_RESET:"Z odkljukanjem tega polja potrjujete, da ste prebrali varnostna navodila in se z njimi strinjate.",
    CHANGE_OF_PARAMETERS:"Sprememba parametrov",
    SELECT_OPTIONS:"Izberite možnosti",
    AUTOMATIC:"Samodejno",
    DESALTING:"Funkcija razsoljevanja",
    SEASON_WASH:"Programi sezonskega pranja",
    SPRING_PROGRAM:"Spomladanski programi pranja",
    SUMMER_PROGRAM:"Poletni programi pranja",
    AUTUMN_PROGRAM:"Jesenski programi pranja",
    WINTER_PROGRAM:"Zimski programi pranja",
    DOOR_CONTROL:"Nadzor vrat",
    SUMMER_DOOR_CONTROL:"Poletje, upravljanje s krmiljenjem vrat v poletnem načinu",
    WINTER_DOOR_CONTROL:"Zima, upravljanje s krmiljenjem vrat v zimskem načinu",
    APPLY_PARAMETERS_CHANGES:"Uporabi spremembe parametrov",
    WORKING_SCHEDULES:"Delovni urniki",
    HOLIDAY_SCHEDULES:"Razpored za praznike",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Prazniki na lokaciji so uspešno ustvarjeni",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Prazniki na lokaciji so uspešno posodobljeni",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Prazniki na lokaciji so uspešno izbrisani",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Delovni urniki se uspešno širijo",
    HOLIDAY_SUCCESSFULLY_DELETED:"Dopust je bil uspešno izbrisan",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Prev",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Prev",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Prev",
    SB_MU_2_2_0:"SB_MU_2_2_0_Prev",
    SB_MU_2_1_0:" SB_MU_2_1_0_Prev",
    SB_MU_2_0_0:" SB_MU_2_0_0_Prev",
    SB_MB_2_2_0:"SB_MB_2_2_0_Prev",
    SB_MB_2_1_0:"SB_MB_2_1_0_Prev",
    SB_MB_2_0_0:"SB_MB_2_0_0_Prev",
    SB_OB_2_2_0:"SB_OB_2_2_0_Prev",
    SB_OB_2_1_0:"SB_OB_2_1_0_Prev",
    SB_OB_2_0_0:"SB_OB_2_0_0_Prev",
    CB3_1_0_0:"CB3_1_0_0_Prev",
    CW35_3_0_0:"CW35_3_0_0_Prev",
    CW35_3_1_0:"CW35_3_1_0_Prev",
    CWB3_3_0_0:"CWB3_3_0_0_Prev",
    CWB3_3_1_0:" CWB3_3_1_0_Prev",
    CW1_3_0_0:" CW1_3_0_0_Prev",
    CW1_3_1_0:" CW1_3_1_0_Prev",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Sušilno sredstvo z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_SHAMPOO:"Šampon z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_FOAM:"Pena z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_WAX_1:"Vosek z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_POLISH_1:"Poliranje z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Čistilo za platišča z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_WAX_2:"Vosek z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Sijaj pnevmatik z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Odstranjevalec mrčesa z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_POLISH_2:"Poliranje z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_INTENSIVE:"Intenzivno z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Aktivna pena z nizko stopnjo polnjenja",
    CHEM_LEVEL_DRYING_AGENT:"Sušilno sredstvo nivo polnjenja",
    CHEM_LEVEL_SHAMPOO:"Šampon nivo polnjenja",
    CHEM_LEVEL_FOAM:"Aktivna pena nivo polnjenja",
    CHEM_LEVEL_WAX_1:"Vosek nivo polnjenja",
    CHEM_LEVEL_POLISH_1:"Poliranje nivo polnjenja",
    CHEM_LEVEL_RIM_CLEANER:"Čistilo za platišča nivo polnjenja",
    CHEM_LEVEL_WAX_2:"Vosek nivo polnjenja",
    CHEM_LEVEL_TYRE_SHINE:"Sijaj pnevmatik nivo polnjenja",
    CHEM_LEVEL_INSECT_REMOVER:"Odstranjevalec mrčesa nivo polnjenja",
    CHEM_LEVEL_POLISH_2:"Poliranje nivo polnjenja",
    CHEM_LEVEL_INTENSIVE:"Intenzivno nivo polnjenja",
    CHEM_LEVEL_FOAM_RAIN:"Aktivna pena nivo polnjenja",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Servisni števec - dvižni pas za strešno krtačo",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Servisni števec - dvižni pas za sušilni stroj",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Servisni števec motornega kabla strešna krtača",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Servisni števec servis črpalke sveže vode",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Servisni števec servisne črpalke uporabljene vode",
    DRYING_AGENT:"Sredstvo za sušenje",
    FOAM_DRYING_AGENT:"Sredstvo za sušenje pene",
    SHAMPOO:"Šampon",
    FOAM:"Pena",
    BRUSH_FOAM:"Pena za krtačo",
    WAX_1:"Vosek",
    FOAM_WAX_1:"Aktivna pena",
    POLISH_1:"Poliranje",
    RIM_CLEANING:"Čistilo za platišča",
    WAX_2:"Vosek",
    FOAM_WAX_2:"Aktivna pena",
    TYRE_SHINE:"Sijaj pnevmatik",
    INSECT_REMOVER:"Odstranjevalec insektov",
    POLISH_2:"Poliranje",
    INTENSIVE_BASIC:"Intenzivno osnovna",
    INTENSIVE_SIDE:"Intenzivno stran",
    INTENSIVE_ROOF_SPRAY_BAR:"Intenzivno nosilec strešne škropilnice",
    TAR_REMOVER:"Odstranjevalec katrana",
    UNDER_CHASSIS_CONVERSATION:"Pogovor pod šasijo",
    STATIONARY_PRE_SPRAY_ARCH:"Stacionarni lok pred pršenjem",
    FOAM_RAIN:"Aktivna pena",
    PRE_CLEANING:"Predčiščenje",
    BRUSH:"Krtača",
    CARE:"Skrb",
    DRYING:"Sušenje",
    DRYING_LOW_NOISE:"Zmanjšan hrup sušenja",
    INTENSIVE_CLEANING:"Intenzivno čiščenje",
    BRUSH_CLEANING:"Čiščenje s krtačo",
    EMPTY_RUN:"Prazen tek",
    DRYING_AID:"Pomoč pri sušenju",
    WAX:"Vosek",
    FOAM_WASH:"Pranje s aktivno peno",
    POLISH:"Poliranje",
    FOAM_POLISH:"Poliranje s peno",
    WHEEL_CLEANING:"Čiščenje koles",
    HIGH_PRESSURE_ROOF:"Streha visok pritisk",
    HIGH_PRESSURE_SIDE:"Stranski visok pritisk",
    DRYER_FORWARD:"Sušilec naprej",
    DRYER_BACKWARD:"Sušilnik nazaj",
    DELETE_ALL_HOLIDAYS:"Izbriši vse praznike za izbrano lokacijo",
    CREATE_NEW_HOLIDAY:"Ustvari novo",
    RESET_INPUTS:"Ponastavi vse vnose za praznike",
    TWENTY_FOUR_HOURS_OPEN:"Odprto 24 ur",
    EVERY_YEAR:"Letno",
    DELETE_HOLIDAY:"Izbriši dopust",
    ADD_NEW_HOLIDAY:"Dodajte nov dopust",
    HOLIDAYS_LIST:"Seznam obstoječih praznikov",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Želite izbrisati vse praznike za izbrano lokacijo?",
    VALIDATION_HOLIDAY_DATE:"Oblika ni pravilna. Uporabite mm-dd",
    FOR_DATE:"Za datum",
    WITH_ID:"Z osebnim dokumentom",
    FROM_HOURS:"Od (h)",
    FROM_MINUTES:"Od (min)",
    TO_HOURS:"Do (h)",
    TO_MINUTES:"Do (min)",
    NOT_MATCH:"Se ne ujema",
    START:"Od",
    STOP:"Do",
    DAILY_TIME:"24-urni seznam",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Individualna nastavitev časa",
    PROGRAM_NOT_STARTED:"Program se še ni začel",
    JETWASH:"Samopostrežni pralni sistem",
    KARCHER_REPORT_1:"Rollover: prikaz prometa na program in skupaj",
    KARCHER_REPORT_2:"Rollover: Začeta pranja na program in skupaj",
    KARCHER_REPORT_3:"Rollover: Opravljena pranja na program in skupaj",
    KARCHER_REPORT_4:"Rollover: Količina začetih pranj preko plačilnega terminala na program in skupaj",
    KARCHER_REPORT_5:"Rollover: število ročno začetih pranj na program in skupno",
    KARCHER_REPORT_6:"Rollover: Količina preklicanih pranj na program in skupaj",
    KARCHER_REPORT_7:"Rollover: Število izpadov napajanja",
    KARCHER_REPORT_8:"Enote SB: Število ur na program pranja, filtrirano po pralnih mestih in skupno",
    KARCHER_REPORT_9:"SB-enote: Prikaz prometa na pralno mesto in skupaj",
    KARCHER_REPORT_10:"SB-enote: števec žetonov/kovancev na kanal kovancev",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Črpalka za svežo vodo",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Črpalka za svežo vodo",
    OPERATION_COUNTER_HP_PUMP_1:"Visokotlačna črpalka 1",
    OPERATION_COUNTER_HP_PUMP_2:"Visokotlačna črpalka 2",
    RELEASE_NOTES:"Različice aplikacije in opombe ob izdaji",
    BACKEND_RELEASE_NOTES:"Opombe ob izdaji platforme:",
    FRONTEND_RELEASE_NOTES:"Opombe ob izdaji spletne aplikacije:",
    SELECTED_FACILITY_TIMEZONE:"Časovni pas za izbrani objekt:",
    REFRESH_PAGE:"Osveži stran",
    REFRESH_MAPS:"Osveži zemljevide",
    PUMPS:"Črpalke",
    RUN_TIME:"Čas delovanja",
    RUN_TIME1:"Čas delovanja 1",
    RUN_TIME2:"Čas delovanja 2",
    PROGRAM_RUNTIME_ACTUATOR:"Pogon za čas delovanja",
    PROGRAM_RUNTIME_ACTUATOR_1:"Pogon za čas delovanja 1",
    PROGRAM_RUNTIME_ACTUATOR_2:"Pogon za čas delovanja 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"Najmanjša vrednost je 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Največja vrednost je 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Uporabite obliko cene x.xx",
    ACTUATION_NOT_ALLOWED:"Aktivacija ni dovoljena za trenutno vlogo uporabnika",
    MAINTENANCE_DAYS:"Dnevi vzdrževanja",
    MAINTENANCE_WASHES:"Vzdrževalna pranja",
    DAILY_FINANCES_POS:"POS",
    POS_INCOME:"Skupni dohodek POS",
    PROPAGATE:"Razmnožiti",
    ALL_DAY_HOURS_SELECTOR:"24-urni izbirnik vrste",
    GET_OPERATING_TIME_FROM_SITE:"Pridobite čas delovanja za trenutno napravo iz delovnih urnikov mesta",
    USER_NOT_VALID:"Uporabnik ni veljaven. Poskusite z drugimi poverilnicami računa.",
    VERIFIED:"Preverjeno",
    RESEND_VERIFICATION_MAIL:"Ponovno pošlji potrditveno e-poštno sporočilo",
    RETURN_TO_DASHBOARD:"Nazaj na nadzorno ploščo",
    ERROR_PAGE_BAD_REQUEST:"400 Slaba zahteva.",
    WASHES:"Število pranj",
    TIME_TO_SERVICE:"Čas za storitev",
    ACCOUNT_ALREADY_ACTIVATED:"Račun je že aktiviran",
    DEVICE_EVENTS:"Dogodki naprave",
    DEVICE_EVENTS_LOG_PULLED:"Prenesen dnevnik dogodkov za napravo",
    EVENTS_PULL_DATE:"Čas prenesenih dogodkov:",
    DEVICE_EVENTS_REFRESH:"Prenesi nove podatke o dogodkih",
    WEB_SOCKETS_CONNECTION_PROBLEM:"Težava z povezavo spletnih vtičev. Poskusite osvežiti stran.",
    INSTALLATION_DATE:"Datum namestitve naprave",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Topli vosek",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"Pranje pod visokim pritiskom",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Močna pena za platišča",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Močna pena",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Ustavi",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Pranje s peno HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Pranje",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Vrhunska nega",
    INFO_TITLE:"Info",
    FOAM_WAX1:"Aktivna pena",
    POLISH1:"Poliranje",
    WAX1:"Vosek",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Podrobnosti o mestu so bile uspešno posodobljene",
    COMPANY:"Podjetje",
    FACILITY_HAS_CHANGER:"Imate menjač?",
    DISABLE_OFFLINE_ALARM:"Onemogoči R2W alarme",
    ASIDE_WORKING_SCHEDULES:"Podrobnosti o mestu v aplikaciji",
    TERMS_OF_SERVICE_R2W_TITLE:"Pogoji uporabe Ready2Wash",
    TERMS_OF_SERVICE_R2W:"Pogoji uporabe Ready2Wash",
    DATA_PROCESSING_TITLE:"Obdelani podatki",
    PRIVACY_POLICY_TITLE:"Politika zasebnosti",
    READY_TO_PAY_TERMS_OF_SERVICE:"Pogoji uporabe Ready2Pay",
    TERMS_AND_SERVICES:"Pogoji in storitve",
    HOURLY: "Vsako uro",
    DAILY: "Dnevno",
    WEEKLY: "Tedensko",
    MONTHLY: "Mesečno",
    YEARLY: "Letno",
    DELETE_ITEM_SUCCESS:"Uspešno ste izbrisali element",
    STATE: "Stanje",
    AVAILABILITY_STATUS_1: "Enota odprta",
    AVAILABILITY_STATUS_2: "Enota zaprta (prazniki)",
    AVAILABILITY_STATUS_3: "Enota zaprta (delovni čas)",
    AVAILABILITY_STATUS_4: "Enota zaprta (okvara)",
    AVAILABILITY_STATUS_5: "Enota zaprta (drugo)",
    AVAILABILITY_VACUUMS_STATUS_1: "Sesalniki niso nameščeni",
    AVAILABILITY_VACUUMS_STATUS_2: "Sesalniki odprti",
    AVAILABILITY_VACUUMS_STATUS_3: "Sesalniki zaprti (prazniki)",
    AVAILABILITY_VACUUMS_STATUS_4: "Sesalniki zaprti (delovni čas)",
    AVAILABILITY_VACUUMS_STATUS_5: "Sesalniki zaprti (okvara)",
    AVAILABILITY_VACUUMS_STATUS_6: "Sesalniki zaprti (drugo)",
    ECOM_AMOUNT: "Skupni Ecom za vse lokacije",
    CAPTURED: "Zajeto",
    DELETE_COMPANY_HISTORY_INFO:"Táto akcia vymaže všetky údaje správ vašej spoločnosti. Túto akciu nie je možné vrátiť späť.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Ste si istý, že chcete natrvalo vymazať všetky údaje správ?",
    VALUE_DATE: "Dátum hodnoty",
    KARCHER_EVENT_NAME_1: "Osnovni toplotni izmenjevalnik regeneriran",
    KARCHER_EVENT_NAME_2: "Regeneracija osnovnega toplotnega izmenjevalnika zaključena",
    KARCHER_EVENT_NAME_3: "Material / serijska številka",
    KARCHER_EVENT_NAME_4: "Sistem je razkužen",
    KARCHER_EVENT_NAME_5: "HP črpalka 1 razkužena",
    KARCHER_EVENT_NAME_6: "HP črpalka 2 razkužena",
    KARCHER_EVENT_NAME_7: "HP črpalka 3 razkužena",
    KARCHER_EVENT_NAME_8: "HP črpalka 4 razkužena",
    KARCHER_EVENT_NAME_9: "HP črpalka 5 razkužena",
    KARCHER_EVENT_NAME_10: "Pralno mesto 1 zaklenjeno",
    KARCHER_EVENT_NAME_11: "Pralno mesto 2 zaklenjeno",
    KARCHER_EVENT_NAME_12: "Pralno mesto 3 zaklenjeno",
    KARCHER_EVENT_NAME_13: "Pralno mesto 4 zaklenjeno",
    KARCHER_EVENT_NAME_14: "Pralno mesto 5 zaklenjeno",
    KARCHER_EVENT_NAME_15: "Pralno mesto 6 zaklenjeno",
    KARCHER_EVENT_NAME_16: "Pralno mesto 7 zaklenjeno",
    KARCHER_EVENT_NAME_17: "Pralno mesto 8 zaklenjeno",
    KARCHER_EVENT_NAME_18: "Posodobitev se je začela",
    KARCHER_EVENT_NAME_19: "Posodobitev zaključena",
    KARCHER_EVENT_NAME_20: "Začetek WS Reg",
    KARCHER_EVENT_NAME_21: "Konec WS Reg",
    KARCHER_EVENT_NAME_22: "WS 75%-senzor",
    KARCHER_EVENT_NAME_23: "Tehnična napaka",
    KARCHER_EVENT_NAME_24: "Operativna napaka",
    KARCHER_EVENT_NAME_25: "Enota vklopljena",
    KARCHER_EVENT_NAME_26: "Enota izklopljena",
    KARCHER_EVENT_NAME_27: "Omarica 1 zaprta",
    KARCHER_EVENT_NAME_28: "Omarica 2 zaprta",
    KARCHER_EVENT_NAME_29: "Omarica 3 zaprta",
    KARCHER_EVENT_NAME_30: "Omarica 4 zaprta",
    KARCHER_EVENT_NAME_31: "Omarica 5 zaprta",
    KARCHER_EVENT_NAME_32: "Omarica 6 zaprta",
    KARCHER_EVENT_NAME_33: "Omarica 7 zaprta",
    KARCHER_EVENT_NAME_34: "Omarica 8 zaprta",
    KARCHER_EVENT_NAME_35: "HP črpalka postaja 1",
    KARCHER_EVENT_NAME_36: "HP črpalka postaja 2",
    KARCHER_EVENT_NAME_37: "HP črpalka postaja 3",
    KARCHER_EVENT_NAME_38: "HP črpalka postaja 4",
    KARCHER_EVENT_NAME_39: "HP črpalka postaja 5",
    KARCHER_EVENT_NAME_40: "HP črpalka postaja 6",
    KARCHER_EVENT_NAME_41: "HP črpalka postaja 7",
    KARCHER_EVENT_NAME_42: "HP črpalka postaja 8",
    KARCHER_EVENT_NAME_43: "Gorilnik",
    KARCHER_EVENT_NAME_44: "Ventilator gorilnika",
    KARCHER_EVENT_NAME_45: "Črpalka za toplo vodo",
    KARCHER_EVENT_NAME_46: "Črpalka za zaščito pred zmrzaljo",
    KARCHER_EVENT_NAME_47: "Osmotska črpalka",
    KARCHER_EVENT_NAME_48: "Talno ogrevanje",
    KARCHER_EVENT_NAME_49: "Ogrevanje cevi",
    KARCHER_EVENT_NAME_50: "Mikro/čiščenje platišč",
    KARCHER_EVENT_NAME_51: "Črpalka za pranje podvozja",
    KARCHER_EVENT_NAME_52: "Penilna črpalka Booster",
    KARCHER_EVENT_NAME_53: "Sesalnik 1",
    KARCHER_EVENT_NAME_54: "Sesalnik 2",
    KARCHER_EVENT_NAME_55: "Sesalnik 3",
    KARCHER_EVENT_NAME_56: "Sesalnik 4",
    KARCHER_EVENT_NAME_57: "Sesalnik 5",
    KARCHER_EVENT_NAME_58: "Sesalnik 6",
    KARCHER_EVENT_NAME_59: "Sesalnik 7",
    KARCHER_EVENT_NAME_60: "Sesalnik 8",
    KARCHER_EVENT_NAME_61: "Sesalnik 9",
    KARCHER_EVENT_NAME_62: "Sesalnik 10",
    KARCHER_EVENT_NAME_63: "Sesalnik 11",
    KARCHER_EVENT_NAME_64: "Sesalnik 12",
    KARCHER_EVENT_NAME_65: "Črpalka za čiščenje platišč",
    KARCHER_EVENT_NAME_66: "Mikro črpalka",
    KARCHER_EVENT_NAME_67: "Intenzivna črpalka",
    KARCHER_EVENT_NAME_68: "Turbina sesalnika 1",
    KARCHER_EVENT_NAME_69: "Filter sesalnika 1",
    KARCHER_EVENT_NAME_70: "Turbina sesalnika 2",
    KARCHER_EVENT_NAME_71: "Filter sesalnika 2",
    KARCHER_EVENT_NAME_72: "Turbina sesalnika 3",
    KARCHER_EVENT_NAME_73: "Filter sesalnika 3",
    KARCHER_EVENT_NAME_74: "Turbina sesalnika 4",
    KARCHER_EVENT_NAME_75: "Filter sesalnika 4",
    KARCHER_EVENT_NAME_76: "Turbina sesalnika 5",
    KARCHER_EVENT_NAME_77: "Filter sesalnika 5",
    KARCHER_EVENT_NAME_78: "Turbina sesalnika 6",
    KARCHER_EVENT_NAME_79: "Filter sesalnika 6",
    KARCHER_EVENT_NAME_80: "Turbina sesalnika 7",
    KARCHER_EVENT_NAME_81: "Filter sesalnika 7",
    KARCHER_EVENT_NAME_82: "Turbina sesalnika 8",
    KARCHER_EVENT_NAME_83: "Filter sesalnika 8",
    KARCHER_EVENT_NAME_84: "Turbina sesalnika 9",
    KARCHER_EVENT_NAME_85: "Filter sesalnika 9",
    KARCHER_EVENT_NAME_86: "Turbina sesalnika 10",
    KARCHER_EVENT_NAME_87: "Filter sesalnika 10",
    KARCHER_EVENT_NAME_88: "Turbina sesalnika 11",
    KARCHER_EVENT_NAME_89: "Filter sesalnika 11",
    KARCHER_EVENT_NAME_90: "Turbina sesalnika 12",
    KARCHER_EVENT_NAME_91: "Filter sesalnika 12",
    INSERT_TOKEN: "Vnesite žetone in zaženite storitev",
    OPEN_SESSION: "Seja je uspešno odprta",
    IN_PROGRESS: "V teku ...",
    TOKEN_INSERTED: "Žetoni so bili uspešno vstavljeni",
    EXPIRED_SESSION: "Seja je potekla",
    TWO_DIGIT_INTEGER_VALIDATION: "Uporabite največ dvomestno celo število",
    KARCHER_OPERATION_COUNTER_1: "Pralna postaja 1 HP črpalka",
    KARCHER_OPERATION_COUNTER_2: "Pralna postaja 1 kemijska črpalka 1",
    KARCHER_OPERATION_COUNTER_3: "Pralna postaja 1 kemijska črpalka 2",
    KARCHER_OPERATION_COUNTER_4: "Pralna postaja 1 kemijska črpalka 3",
    KARCHER_OPERATION_COUNTER_5: "Pralna postaja 1 kemijska črpalka 4",
    KARCHER_OPERATION_COUNTER_6: "Pralna postaja 2 HP črpalka",
    KARCHER_OPERATION_COUNTER_7: "Pralna postaja 2 kemijska črpalka 1",
    KARCHER_OPERATION_COUNTER_8: "Pralna postaja 2 kemijska črpalka 2",
    KARCHER_OPERATION_COUNTER_9: "Pralna postaja 2 kemijska črpalka 3",
    KARCHER_OPERATION_COUNTER_10: "Pralna postaja 2 kemijska črpalka 4",
    KARCHER_OPERATION_COUNTER_11: "Pralna postaja 3 HP črpalka",
    KARCHER_OPERATION_COUNTER_12: "Pralna postaja 3 kemijska črpalka 1",
    KARCHER_OPERATION_COUNTER_13: "Pralna postaja 3 kemijska črpalka 2",
    KARCHER_OPERATION_COUNTER_14: "Pralna postaja 3 kemijska črpalka 3",
    KARCHER_OPERATION_COUNTER_15: "Pralna postaja 3 kemijska črpalka 4",
    KARCHER_OPERATION_COUNTER_16: "Pralna postaja 4 HP črpalka",
    KARCHER_OPERATION_COUNTER_17: "Pralna postaja 4 kemijska črpalka 1",
    KARCHER_OPERATION_COUNTER_18: "Pralna postaja 4 kemijska črpalka 2",
    KARCHER_OPERATION_COUNTER_19: "Pralna postaja 4 kemijska črpalka 3",
    KARCHER_OPERATION_COUNTER_20: "Pralna postaja 4 kemijska črpalka 4",
    KARCHER_OPERATION_COUNTER_21: "Pralna postaja 5 HP črpalka",
    KARCHER_OPERATION_COUNTER_22: "Pralna postaja 5 kemijska črpalka 1",
    KARCHER_OPERATION_COUNTER_23: "Pralna postaja 5 kemijska črpalka 2",
    KARCHER_OPERATION_COUNTER_24: "Pralna postaja 5 kemijska črpalka 3",
    KARCHER_OPERATION_COUNTER_25: "Pralna postaja 5 kemijska črpalka 4",
    KARCHER_OPERATION_COUNTER_26: "Pralna postaja 6 HP črpalka",
    KARCHER_OPERATION_COUNTER_27: "Pralna postaja 6 kemijska črpalka 1",
    KARCHER_OPERATION_COUNTER_28: "Pralna postaja 6 kemijska črpalka 2",
    KARCHER_OPERATION_COUNTER_29: "Pralna postaja 6 kemijska črpalka 3",
    KARCHER_OPERATION_COUNTER_30: "Pralna postaja 6 kemijska črpalka 4",
    KARCHER_OPERATION_COUNTER_31: "Pralna postaja 7 HP črpalka",
    KARCHER_OPERATION_COUNTER_32: "Pralna postaja 7 kemijska črpalka 1",
    KARCHER_OPERATION_COUNTER_33: "Pralna postaja 7 kemijska črpalka 2",
    KARCHER_OPERATION_COUNTER_34: "Pralna postaja 7 kemijska črpalka 3",
    KARCHER_OPERATION_COUNTER_35: "Pralna postaja 7 kemijska črpalka 4",
    KARCHER_OPERATION_COUNTER_36: "Pralna postaja 8 HP črpalka",
    KARCHER_OPERATION_COUNTER_37: "Pralna postaja 8 kemijska črpalka 1",
    KARCHER_OPERATION_COUNTER_38: "Pralna postaja 8 kemijska črpalka 2",
    KARCHER_OPERATION_COUNTER_39: "Pralna postaja 8 kemijska črpalka 3",
    KARCHER_OPERATION_COUNTER_40: "Pralna postaja 8 kemijska črpalka 4",
    KARCHER_OPERATION_COUNTER_41: "Črpalka za osmozo",
    KARCHER_OPERATION_COUNTER_42: "Generator tople vode",
    KARCHER_OPERATION_COUNTER_43: "Črpalka za zaščito proti zmrzovanju",
    KARCHER_OPERATION_COUNTER_44: "WSO filtrirne kartuše",
    KARCHER_OPERATION_COUNTER_45: "Ogrevalna črpalka za pralno postajo",
    KARCHER_OPERATION_COUNTER_46: "Črpalka za toplo vodo",
    KARCHER_OPERATION_COUNTER_47: "Grelnik za penaste cevi",
    KARCHER_OPERATION_COUNTER_48: "Črpalka za pranje koles",
    KARCHER_OPERATION_COUNTER_49: "Mikroemulzijska črpalka",
    KARCHER_OPERATION_COUNTER_50: "Intenzivna črpalka za peno",
    KARCHER_OPERATION_COUNTER_51: "Sesalec 1 turbina 1",
    KARCHER_OPERATION_COUNTER_52: "Sesalec 1 filter 1",
    KARCHER_OPERATION_COUNTER_53: "Sesalec 1 turbina 2",
    KARCHER_OPERATION_COUNTER_54: "Sesalec 1 filter 2",
    KARCHER_OPERATION_COUNTER_55: "Sesalec 2 turbina 1",
    KARCHER_OPERATION_COUNTER_56: "Sesalec 2 filter 1",
    KARCHER_OPERATION_COUNTER_57: "Sesalec 2 turbina 2",
    KARCHER_OPERATION_COUNTER_58: "Sesalec 2 filter 2",
    KARCHER_OPERATION_COUNTER_59: "Sesalec 3 turbina 1",
    KARCHER_OPERATION_COUNTER_60: "Sesalec 3 filter 1",
    KARCHER_OPERATION_COUNTER_61: "Sesalec 3 turbina 2",
    KARCHER_OPERATION_COUNTER_62: "Sesalec 3 filter 2",
    KARCHER_OPERATION_COUNTER_63: "Sesalec 4 turbina 1",
    KARCHER_OPERATION_COUNTER_64: "Sesalec 4 filter 1",
    KARCHER_OPERATION_COUNTER_65: "Sesalec 4 turbina 2",
    KARCHER_OPERATION_COUNTER_66: "Sesalec 4 filter 2",
    KARCHER_OPERATION_COUNTER_67: "Sesalec 5 turbina 1",
    KARCHER_OPERATION_COUNTER_68: "Sesalec 5 filter 1",
    KARCHER_OPERATION_COUNTER_69: "Sesalec 5 turbina 2",
    KARCHER_OPERATION_COUNTER_70: "Sesalec 5 filter 2",
    KARCHER_OPERATION_COUNTER_71: "Sesalec 6 turbina 1",
    KARCHER_OPERATION_COUNTER_72: "Sesalec 6 filter 1",
    KARCHER_OPERATION_COUNTER_73: "Sesalec 6 turbina 2",
    KARCHER_OPERATION_COUNTER_74: "Sesalec 6 filter 2",
    KARCHER_OPERATION_COUNTER_75: "Odstranite kondenzatno vodo iz kompresorja",
    KARCHER_OPERATION_COUNTER_76: "Preverite sistem proti zmrzovanju",
    KARCHER_OPERATION_COUNTER_77: "Ventilator gorilnika",
    KARCHER_OPERATION_COUNTER_78: "Ojačitvena črpalka za peno",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Seznam podatkov je večji od 10000 elementov",
    KARCHER_POINT_NAME_1: "Praznik",
    KARCHER_POINT_NAME_2: "Ponedeljek",
    KARCHER_POINT_NAME_3: "Torek",
    KARCHER_POINT_NAME_4: "Sreda",
    KARCHER_POINT_NAME_5: "Četrtek",
    KARCHER_POINT_NAME_6: "Petek",
    KARCHER_POINT_NAME_7: "Sobota",
    KARCHER_POINT_NAME_8: "Nedelja",
    KARCHER_POINT_NAME_9: "Sesalniki Praznik",
    KARCHER_POINT_NAME_10: "Sesalniki Ponedeljek",
    KARCHER_POINT_NAME_11: "Sesalniki Torek",
    KARCHER_POINT_NAME_12: "Sesalniki Sreda",
    KARCHER_POINT_NAME_13: "Sesalniki Četrtek",
    KARCHER_POINT_NAME_14: "Sesalniki Petek",
    KARCHER_POINT_NAME_15: "Sesalniki Sobota",
    KARCHER_POINT_NAME_16: "Sesalniki Nedelja",
    KARCHER_POINT_NAME_17: "Razsvetljava Praznik",
    KARCHER_POINT_NAME_18: "Razsvetljava Ponedeljek",
    KARCHER_POINT_NAME_19: "Razsvetljava Torek",
    KARCHER_POINT_NAME_20: "Razsvetljava Sreda",
    KARCHER_POINT_NAME_21: "Razsvetljava Četrtek",
    KARCHER_POINT_NAME_22: "Razsvetljava Petek",
    KARCHER_POINT_NAME_23: "Razsvetljava Sobota",
    KARCHER_POINT_NAME_24: "Razsvetljava Nedelja",
    KARCHER_POINT_NAME_25: "Program 0",
    KARCHER_POINT_NAME_26: "Program 1",
    KARCHER_POINT_NAME_27: "Program 2",
    KARCHER_POINT_NAME_28: "Program 3",
    KARCHER_POINT_NAME_29: "Program 4",
    KARCHER_POINT_NAME_30: "Program 5",
    KARCHER_POINT_NAME_31: "Program 6",
    KARCHER_POINT_NAME_32: "Program 7",
    KARCHER_POINT_NAME_33: "Program 8",
    KARCHER_POINT_NAME_34: "Program 9",
    KARCHER_POINT_NAME_35: "Program 10",
    KARCHER_POINT_NAME_36: "Program 11",
    KARCHER_POINT_NAME_37: "Program 12",
    KARCHER_POINT_NAME_38: "Program 13",
    KARCHER_POINT_NAME_39: "Program 14",
    KARCHER_POINT_NAME_40: "Program 15",
    KARCHER_POINT_NAME_41: "Program 16",
    KARCHER_POINT_NAME_42: "Program 17",
    KARCHER_POINT_NAME_43: "Program 18",
    KARCHER_POINT_NAME_44: "Program 19",
    KARCHER_POINT_NAME_45: "Program 20",
    KARCHER_POINT_NAME_46: "Program 21",
    KARCHER_POINT_NAME_47: "Program 22",
    KARCHER_POINT_NAME_48: "Program 23",
    KARCHER_POINT_NAME_49: "Program 24",
    KARCHER_POINT_NAME_50: "Program 25",
    KARCHER_POINT_NAME_51: "Program 26",
    KARCHER_POINT_NAME_52: "Program 27",
    KARCHER_POINT_NAME_53: "Program 28",
    KARCHER_POINT_NAME_54: "Program 29",
    KARCHER_POINT_NAME_55: "Program 30",
    KARCHER_POINT_NAME_56: "Program 31",
    KARCHER_POINT_NAME_57: "Program 32",
    QR_CODE: "QR koda",
    ACCEPT_TERMS_AND_CONDITIONS: "Sprejmi pogoje uporabe",
    CREATE_AND_PRINT_VOUCHERS: "Ustvari in natisni kupone",
    CODE_PREFIX_QUESTION: "Predpona kode ni vnesena",
    CODE_PREFIX_QUESTION_TEXT: "Želite nadaljevati brez predpone kode?",
    ISSUED_DATE: "Datum izdaje",
    VOUCHER_VALIDITY_DAYS: "Veljavnost kupona (dnevi)",
    VALIDATION_ONLY_NUMBERS: "Dovoljene so samo številke",
    REPRINT_VOUCHERS: "Natisni kopijo kuponov",
    EXPIRY_DATE: "Velja do"
  });
})();
